import React from 'react';

import { Wrapper } from '@pkg/components';
import { Button, ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';
import { Sizes } from '@pkg/components/Sections/Profile/Buttons/Button/types';
import { Colors } from '@pkg/components/Sections/Profile/Buttons/ButtonBase';

import { type PagingParams } from '@app/client';

interface Props {
    fetchNextPage: VoidFunction;
    isFetching: boolean;
    variant?: 'primary' | 'buttoned';
    fetchPreviousPage?: VoidFunction;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
    pagingParams?: PagingParams;
}

export const Pagination = ({
    fetchNextPage,
    isFetching,
    fetchPreviousPage,
    pagingParams,
    hasNextPage,
    hasPreviousPage,
    variant = 'primary',
}: Props) => {
    if (variant === 'buttoned') {
        const currentPage = pagingParams?.page || 0;
        const pages = Math.floor((pagingParams?.total || 1) / (pagingParams?.limit || 1)) + 1;
        return (
            <Wrapper direction="row" alignItems="center" justifyContent="space-between">
                <ButtonIcon
                    onClick={fetchPreviousPage}
                    disabled={!hasPreviousPage}
                    color={'transparent'}
                    size={Sizes.small}
                >
                    ⇦
                </ButtonIcon>
                <p>{`Page ${currentPage + 1} of ${pages}`}</p>
                <ButtonIcon color={'transparent'} size={Sizes.small} onClick={fetchNextPage} disabled={!hasNextPage}>
                    ⇨
                </ButtonIcon>
            </Wrapper>
        );
    }
    return (
        <Wrapper width="100px" margin="20px auto">
            <Button size={Sizes.xsmall} color={Colors.transparent} onClick={fetchNextPage} loading={isFetching}>
                Load more
            </Button>
        </Wrapper>
    );
};
